import { render, staticRenderFns } from "./demandDetails.vue?vue&type=template&id=2f026bce&scoped=true&"
import script from "./demandDetails.vue?vue&type=script&lang=js&"
export * from "./demandDetails.vue?vue&type=script&lang=js&"
import style0 from "./demandDetails.vue?vue&type=style&index=0&id=2f026bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f026bce",
  null
  
)

export default component.exports